export enum CallerType {
    LEAD = 'lead',
    CUSTOMER = 'customer',
    OTHER = 'other',
}
